import { Component, OnInit, Type } from '@angular/core';
import { finalize, skip, takeUntil } from 'rxjs/operators';
import {
  getAccountId,
  loadAllAccounts,
  lookupAccounts,
} from './history.actions';
import { Store } from '@ngrx/store';
import * as reducers from '../reducers';
import { SelectionModel } from '@angular/cdk/collections';
import { MatCheckboxChange } from '@angular/material/checkbox';
import { FormGroup, FormBuilder } from '@angular/forms';
import { Subject } from 'rxjs';
import { MatTableDataSource } from '@angular/material/table';
import { Go } from '@app/router/router.actions';
import { SuccessSnackbarComponent } from '@app/shared/success-snackbar.component';
import { MatSnackBar } from '@angular/material/snack-bar';
import { PaginatedListPayload } from '@app/shared/interfaces/paginated-list-payload.interface';
import { loadAllChats, lookupChats } from '@app/chats/chats.actions';
import { Transcript } from '@app/shared/interfaces/transcript.interface';
import { OnDestroy } from '@angular/core';
import { MatAutocompleteSelectedEvent } from '@angular/material/autocomplete';
import { loadUsernames } from './history.actions';
import { SnackbarNotification } from '@app/shared/interfaces/snackbar-notification.interface';
import { FailureSnackbarComponent } from '@app/shared/failure-snackbar.component';
import { DateRange, MenuItem } from '@app/shared/models/shared.model';
import { formatDateToString } from '@app/app.constants';
@Component({
  selector: 'app-history',
  templateUrl: './history.component.html',
  styleUrls: ['./history.component.scss'],
})
export class HistoryComponent implements OnInit, OnDestroy {
  quote: string | undefined;
  isLoading = false;
  limit = 50;
  selection = new SelectionModel<any>(true, []);
  destroy$: Subject<boolean> = new Subject<boolean>();
  displayedColumns: string[] = [
    // 'checkbox',
    'date',
    'email',
    'title',
    'summary',
  ];
  defaultColumns = [
    // { id: 'checkbox', name: 'Checkbox Selection', hidden: false },
    { id: 'date', name: 'Date', hidden: false },
    { id: 'email', name: 'Student Email', hidden: false, disable: true },
    { id: 'title', name: 'Prompt Summary', hidden: false },
    { id: 'summary', name: 'Chat Summary', hidden: false },
  ];
  dataObject: PaginatedListPayload = {
    offset: 0,
    limit: this.limit,
    sortAscending: false,
    sortColumns: ['date'],
    allSessions: true,
    gradeLevels: null,
    usernames: null,
  };
  datePickerRange: { start: Date; end: Date } = {
    // last 7 days
    start: new Date(Date.now() - 7 * 24 * 60 * 60 * 1000),
    end: new Date(Date.now()),
  };
  selectedPeriod: MenuItem;
  showDateRangePicker = false;
  maxDate = new Date();

  columnNames: string[] = [
    // 'Checkbox Selection',
    'Date',
    'Student Email',
    'Prompt Summary',
    'Chat Summary',
  ];
  componentMap: { [key: string]: [Type<unknown>, string] } = {
    SUCCESS: [SuccessSnackbarComponent, 'mat-snack-bar-success'],
    FAILURE: [FailureSnackbarComponent, 'mat-snack-bar-failure'],
  };
  accountsFilterForm: FormGroup;
  dataSource: any;
  currentPage = 0;
  totalCount = 0;
  chats: Transcript[] = [];
  pageSizeOptions = [25, 50, 100];
  filterForm: FormGroup;
  filteredList: string[];
  isPrivacyEnabled = true;
  constructor(
    private store: Store<reducers.State>,
    private formBuilder: FormBuilder,
    private snackBar: MatSnackBar
  ) {
    this.dataSource = [];
    this.filterForm = this.formBuilder.group({
      searchfilter: [''],
    });
    this.accountsFilterForm = this.formBuilder.group({
      searchfilter: [],
    });
  }

  ngOnInit() {
    this.getChats();

    this.store
      .select(reducers.getHistoryNofications)
      .pipe(takeUntil(this.destroy$))
      .subscribe((notification: SnackbarNotification) => {
        if (notification.type) {
          const [component, panelClass] = this.componentMap[notification.type];
          this.snackBar.openFromComponent(component, {
            data: notification.data,
            panelClass: [panelClass],
            verticalPosition: 'top',
            horizontalPosition: 'end',
          });
        }
      });
    this.store
      .select(reducers.getUsernames)
      .pipe(takeUntil(this.destroy$))
      .subscribe((users: string[]) => {
        this.filteredList = users;
      });
    this.store
      .select(reducers.getChats)
      .pipe(takeUntil(this.destroy$))
      .subscribe((chats: any) => {
        this.chats = chats;
        this.dataSource = new MatTableDataSource(this.chats);
      });
    this.store
      .select(reducers.getChatsTotalCount)
      .pipe(takeUntil(this.destroy$))
      .subscribe((totalCount: number) => {
        this.totalCount = totalCount;
      });
    this.store
      .select(reducers.getChatsOffset)
      .pipe(takeUntil(this.destroy$))
      .subscribe((offset: number) => {
        this.currentPage = offset;
      });
    this.store
      .select(reducers.getLoggedInUserInfo)
      .pipe(takeUntil(this.destroy$))
      .subscribe((userInfo) => {
        this.isPrivacyEnabled = userInfo.enhanced_privacy;
        this.getChats();
      });
  }
  sortData(sort: any) {
    this.dataObject = Object.assign({}, this.dataObject, {
      sortColumns: [sort.active || 'date'],
      sortAscending: sort.direction === 'asc',
    });
    this.getChats();
  }

  getPageData() {
    return this.dataSource._pageData(
      this.dataSource._orderData(this.dataSource.filteredData)
    );
  }

  isEntirePageSelected() {
    return this.getPageData().every((row: any) =>
      this.selection.isSelected(row)
    );
  }

  masterToggle(checkboxChange: MatCheckboxChange) {
    this.isEntirePageSelected()
      ? this.selection.deselect(...this.getPageData())
      : this.selection.select(...this.getPageData());
  }

  onPageChange(event: any) {
    window.scrollTo(0, 0);
    this.currentPage = event.pageIndex;
    this.dataObject = Object.assign({}, this.dataObject, {
      limit: event.pageSize,
      offset: event.pageSize * event.pageIndex,
    });
    this.getChats();
  }

  onSearchInputChange(event: any) {
    //get autocomplete list
    const payload = {
      category: 'email',
      q: event.target.value?.trim(),
    };
    this.store.dispatch(loadUsernames.init({ payload: payload }));
  }

  getChatHistory(row: any) {
    this.store.dispatch(
      new Go({
        path: [`/history/details/${row.uuid}`],
      })
    );
  }
  onSearch(event: any) {
    this.dataObject = Object.assign({}, this.dataObject, {
      searchText: event?.target?.value || null,
    });
    this.store.dispatch(lookupChats.init({ payload: this.dataObject }));
  }
  goToAddAccount() {
    this.store.dispatch(
      new Go({
        path: ['/add'],
      })
    );
  }

  onGradeChange(event: Event) {
    this.dataObject = Object.assign({}, this.dataObject, {
      gradeLevels: event,
    });
    this.getChats();
  }

  onUsernameChange(event: Event) {
    this.dataObject = Object.assign({}, this.dataObject, {
      usernames: event,
    });
    this.getChats();
  }

  filterByDateChange(event: MenuItem) {
    if (!event) return;
    this.selectedPeriod = event;

    // if custom range is selected, show date range picker
    // else calculate start and end date based on selected period
    // and hide date range picker
    if (event.value === 'customrange') {
      this.showDateRangePicker = true;
    } else {
      this.showDateRangePicker = false;

      const days = +event.value;
      const today = Date.now();
      this.datePickerRange = {
        start: new Date(
          // Subtract the specified number of days (in millis) from today
          today - days * 24 * 60 * 60 * 1000
        ),
        end: new Date(today),
      };
    }
  }
  /**
   * Handles updating the date range selected using the dateRange form emitted from
   * the date-range-picker component.
   */
  handleDateChange(emittedObj: { dateRange: DateRange }) {
    this.datePickerRange = {
      start: emittedObj.dateRange.start,
      end: emittedObj.dateRange.end,
    };

    if (this.datePickerRange.start && this.datePickerRange.end) {
      this.dataObject = Object.assign({}, this.dataObject, {
        startDate: formatDateToString(this.datePickerRange['start']),
        endDate: formatDateToString(this.datePickerRange['end']),
      });

      this.getChats();
    }
  }

  getChats() {
    if (!this.isPrivacyEnabled) {
      this.store.dispatch(loadAllChats.init({ payload: this.dataObject }));
    }
  }

  ngOnDestroy() {
    this.destroy$.next(true);
    this.destroy$.unsubscribe();
  }
}
